import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { InclusionFastComponent } from '@app/patients/modals/inclusion-fast/inclusion-fast.component';
import { ButtonMobileAction } from '@ui/btn-action-mobile';
import { AuthService } from '@services/security';
import { ModalRightService } from '@services/modal';

import { UntilDestroy } from '@ngneat/until-destroy';
import { ModalFullService } from '@services/modal/modal-full.service';
import { ExportAtComponent } from '@app/dashboard/modals/export-at/export-at.component';
import { RouteDetectorService } from './services/route-detector.service';

@UntilDestroy()
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent implements OnInit {
    private search: string;

    public get user$(): Observable<any> {
        return this.authService.currentUser;
    }

    actions;

    constructor(
        private readonly router: Router,
        private readonly routeDetectorService: RouteDetectorService,
        public authService: AuthService,
        private readonly modalRightService: ModalRightService,
        private readonly modalFullService: ModalFullService,
    ) {}

    public ngOnInit(): void {
        this._initActions();
        this.routeDetectorService.detectRoute();
    }

    private _initActions(): void {
        this.actions = this._getActions();
    }

    private _getActions(): ButtonMobileAction[] {
        const actions = [];
        if (this.authService.canIncludePatient.cardio) {
            actions.push({
                action: this._openFastInclusion.bind(this),
                translate: 'patients.addPatientCardio',
            });
        }
        if (this.authService.canIncludePatient.nephro) {
            actions.push({
                action: this._openNephroInclusion.bind(this),
                translate: 'patients.addPatientNephro',
            });
        }
        if (actions.length === 1) {
            actions[0].translate = 'patients.add';
        }

        return actions;
    }

    private _openFastInclusion() {
        this.modalFullService.open(InclusionFastComponent);
    }

    private _openNephroInclusion() {
        this.router.navigate(['multiform','inclusion-nephro','new']);
    }

    exportAT() {
        this.modalRightService.open(ExportAtComponent);
    }

    searchValue(value: string) {
        this.search = value;
    }
}
